<div class="page-body-wrapper" [rvIsLoading]="listDataService.loading">
  <rn-account-status-warning context="banner"/>
  <div class="holds-header flex-row flex-center-space-between">
    <div class="mat-headline-4">On Hold <span class="hold-count">({{ listDataService.totalCount }})</span></div>
    @if (organizationSelectors.usesMEL | select) {
      <a mat-stroked-button class="melcat-link mat-subtitle-2" href="https://elibrary.mel.org/" target="_blank" rel="noopener">
        MeLCat
      </a>
    }
  </div>
  <div class="select-all">
    <mat-checkbox
      (change)="$event ? toggleAll() : null"
      [checked]="selection.hasValue() && allSelected()"
      [indeterminate]="selection.hasValue() && !allSelected()">
      Select All
    </mat-checkbox>
  </div>
  <table mat-table class="non-mobile-table" aria-label="Holds" [dataSource]="listDataService.data">
    <ng-container matColumnDef="checkbox">
      <th mat-header-cell *matHeaderCellDef scope="col"></th>
      <td mat-cell *matCellDef="let hold" (click)="$event.stopPropagation()">
        <mat-checkbox
          (change)="$event ? selection.toggle(hold) : null"
          [checked]="selection.isSelected(hold)"/>
      </td>
    </ng-container>
    <ng-container matColumnDef="mobile">
      <th mat-header-cell *matHeaderCellDef scope="col"></th>
      <td mat-cell *matCellDef="let hold">
        <ng-container *ngTemplateOutlet="mobileTableEntry; context:{hold: hold}"/>
      </td>
    </ng-container>
    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef scope="col">Title</th>
      <td mat-cell *matCellDef="let hold" class="table-row-title pointer">
        <span (click)="routingService.goToCatalogRecordDetail(hold.catalogRecordId)" class="pointer">
          {{ hold.itemTitle }}
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="materialType">
      <th mat-header-cell *matHeaderCellDef scope="col">Material Type</th>
      <td mat-cell *matCellDef="let hold" class="pointer">
        {{ hold.materialType?.description }}
      </td>
    </ng-container>
    <ng-container matColumnDef="location">
      <th mat-header-cell *matHeaderCellDef scope="col">Pickup Location</th>
      <td mat-cell *matCellDef="let hold" class="pointer">
        @if (hold.pickupBranchAddress) {
          <a [href]="getBranchDirectionsURI(hold)" target="_blank" (click)="$event.stopPropagation()"
             rel="noopener" class="directions-link">
            {{ hold.pickupBranchName }}
          </a>
        } @else {
          <span>{{ hold.pickupBranchName }}</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef scope="col">Status</th>
      <td mat-cell *matCellDef="let hold" class="pointer">
        <rn-hold-status [hold]="hold"/>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef scope="col">Actions</th>
      <td mat-cell *matCellDef="let hold" (click)="$event.stopPropagation()">
        @if (isCancellableStatus(hold)) {
          <mat-icon class="pointer action-button-spacer"
                    (click)="cancelHolds([hold])" matTooltip="Cancel" matTooltipPosition="above">
            highlight_off
          </mat-icon>
        }
        @if (isDeletableStatus(hold)) {
          <mat-icon class="pointer action-button-spacer"
                    (click)="deleteHolds([hold])" matTooltip="Delete" matTooltipPosition="above">
            delete_outline
          </mat-icon>
        }
        @if (isRequestedStatus(hold)) {
          <mat-icon class="pointer"
                    (click)="pauseHolds([hold])" matTooltip="Pause" matTooltipPosition="above">
            pause_circle_outline
          </mat-icon>
        }
        @if (isPausedStatus(hold)) {
          <mat-icon class="pointer"
                    (click)="unpauseHolds([hold])" matTooltip="Unpause" matTooltipPosition="above">
            play_circle_outline
          </mat-icon>
        }
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="mx-bold-underline"></tr>
    <tr mat-row *matRowDef="let hold; columns: columnsToDisplay"
        (click)="routingService.goToCatalogRecordDetail(hold.catalogRecordId)" class="mx-taller-row">
    </tr>
  </table>
  @if (listDataService.totalCount === 0) {
    @if (listDataService.filter | async) {
      <div class="empty-list">
        No holds match your current filters.
      </div>
    } @else {
      <div class="empty-list">
        No items on hold.
      </div>
    }
  }
  <rn-pager/>
  <div class="clear-for-footer"></div>
  <div class="save-footer">
    <div class="save-footer-content flex-row flex-center-end">
      <div class="spacer"></div>
      <div class="button-row-right">
        <button mat-icon-button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="mobileHoldButtonMenu" class="hide-gt-xs">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #mobileHoldButtonMenu="matMenu" [overlapTrigger]="false" class="hide-gt-xs">
          <button mat-menu-item
                  [disabled]="!selectionHasDeletableHolds()" (click)="deleteHolds(selection.selected)">
            Delete Holds
          </button>
          <button mat-menu-item
                  [disabled]="!selectionHasCancellableHolds()" (click)="cancelHolds(selection.selected)">
            Cancel Holds
          </button>
          <button mat-menu-item
                  [disabled]="!selectionHasUnpausableHolds()" (click)="unpauseHolds(selection.selected)">
            Unpause Holds
          </button>
        </mat-menu>
        <button mat-stroked-button class="ButtonSmallBlack save-button-group button-cancel hide-xs"
                [disabled]="!selectionHasDeletableHolds()" (click)="deleteHolds(selection.selected)">
          Delete Holds
        </button>
        <button mat-stroked-button class="ButtonSmallBlack save-button-group button-cancel hide-xs"
                [disabled]="!selectionHasCancellableHolds()" (click)="cancelHolds(selection.selected)">
          Cancel Holds
        </button>
        <button mat-stroked-button class="ButtonSmallBlack save-button-group button-cancel hide-xs"
                [disabled]="!selectionHasUnpausableHolds()" (click)="unpauseHolds(selection.selected)">
          Unpause Holds
        </button>
        <button mat-raised-button color="primary" class="ButtonSmallBlack save-button-group save-button"
                [disabled]="!selectionHasPausableHolds()" (click)="pauseHolds(selection.selected)">
          Pause Holds
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #mobileTableEntry let-hold="hold">
  <div class="mobile-table-entry flex-col">
    <a class="mobile-title-link">{{ hold.itemTitle }}</a>
    <span>Material Type: {{ hold.materialType?.description }}</span>
    @if (hold.pickupBranchAddress) {
      <span>Pickup Location:
        <a [href]="getBranchDirectionsURI(hold)" target="_blank" (click)="$event.stopPropagation()" rel="noopener">
          {{ hold.pickupBranchName }}
        </a>
      </span>
    } @else {
      <span>Pickup Location: {{ hold.pickupBranchName }}</span>
    }
    <rn-hold-status [hold]="hold"/>
  </div>
</ng-template>
